import { awsApiInstance } from '../api/aws-api';
import useAuth from '../hooks/auth-hooks';

import { INewPartner, IPostPartnerResponse } from '../models/partner.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates an individual partner
 * 
 * @param {INewPartner} partner the form data
 * 
 * @returns {IPostPartnerResponse} the api response | error 
 */
const UpdateNewPartner = async (partner: INewPartner): Promise<IPostPartnerResponse> => {
  try {
    const { userId } = useAuth()!; 

    const modelData = {
      wpID: userId,
      partnerId: partner.partnerID,
      partnerName: partner.partnerName,
      accountNum: partner.accountNumber,
      exportTo: partner.exportTo,
      fileType: partner.exportFileType
    };

    const { data } =  await awsApiInstance.put(`/partners/${partner.partnerID}`, modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating partner');
    throw(error);
  }
}

export default UpdateNewPartner;